module.exports = {"513225100":"永乐镇","513225101":"漳扎镇","513225103":"双河镇","513225200":"永丰乡","513225201":"永和乡","513225202":"安乐乡","513225203":"白河乡","513225205":"保华乡","513225206":"罗依乡","513225207":"勿角乡","513225208":"马家乡","513225209":"郭元乡","513225210":"草地乡","513225211":"陵江乡","513225212":"黑河乡","513225213":"玉瓦乡","513225214":"大录乡","513225400":"九寨沟国营牧场","513225401":"九寨沟风景名胜管理局"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513225.json
// module id = 2403
// module chunks = 0